import * as types from '../constants/idpAdminActions';
import * as samlConstants from '../constants/samlConstants';
import * as oidcConstants from '../constants/oidcConstants';
import * as messages from '../shared/messages';
import Moment from 'moment';
import * as consts from "../constants/idpAdminConstants";
import {EXTENDED_ATTRIBUTE, REGULAR_USER_ATTRIBUTES} from "../constants/samlConstants";
import {getExtendedAttributes} from "../actions/storage";
import {DEFAULT_SCOPE, NEW_OIDC_SCOPE} from "../constants/oidcConstants";

const initialState = {
  errorMsg: null,
  parseUrlInProgress: false,
  importMetadata: null,
  oidcProfile: {},
  oidcRedirectUris: oidcConstants.DEFAULT_REDIRECT_URIS,
  clientId: '',
  clientSecret: '',
  signature: '',
  idpUserAttributes: samlConstants.DEFAULT_USER_ATTRIBUTES,
  idpUserGroupAttributes: [],
  applicationName: '',
  userFriendlyName: '',
  defaultSamlNameIdFormatEnum: samlConstants.UNSPECIFIED,
  unspecifiedNameIdFormatAttributeEnum: samlConstants.UNSPECIFIED_NAME_ID_USER_PRINCIPAL_NAME,
  selectedImportOption: samlConstants.IMPORT_FROM_URL,
  duplicate: null,
  downloadUrl: '',
  modalExpiredMetadataCertificateIsShown: false,
  spCertificateExpirationMessageType: null,
  certificateValidTo: null,
  lastCertificateRotationDate: null,
  modalStartUsingNewIdpCertificateIsShown: false,
  isApplicationReplaced: false,
  wsFederationProfile: {},
  redirectUri: '',
  showModalWsFedIdpMetadata: false,
  oidcScope: oidcConstants.DEFAULT_SCOPE,
};

function getExpirationMessageType(expirationDateTime) {
  let messageType = null;
  let expirationDate = Moment.utc(expirationDateTime);
  let transitionPeriodStart = Moment.utc(expirationDateTime).subtract(consts.transitionPeriodForSpCertificate, "days");
  let currentDate = new Moment();
  if (currentDate.isBetween(transitionPeriodStart, expirationDate)) {
    messageType = "Info";
  } else if (currentDate.isAfter(expirationDate)) {
    messageType = "Warning";
  } else {
    messageType = "Success";
  }
  return messageType;
}

export default function orgs(state = initialState, action = {}) {
  switch (action.type) {
    case types.PARSE_FROM_URL_START:
      return {
        ...state,
        errorMsg: null,
        parseUrlInProgress: true
      };
    case types.PARSE_FROM_URL_SUCCESS:
      return {
        ...state,
        errorMsg: null,
        importMetadata: action.metadata.parsedMetadata,
        downloadUrl: action.metadata.parsedMetadata.downloadUrl,
        defaultSamlNameIdFormatEnum: action.metadata.parsedMetadata.samlNameIdFormats.filter(
            e => e.samlNameIdFormatEnum
                === state.defaultSamlNameIdFormatEnum).length
        > 0 ? state.defaultSamlNameIdFormatEnum
            : action.metadata.parsedMetadata.defaultSamlNameIdFormatEnum,
        unspecifiedNameIdFormatAttributeEnum: action.metadata.parsedMetadata.unspecifiedNameIdFormatAttributeEnum,
        selectedImportOption: samlConstants.IMPORT_FROM_URL,
        duplicate: action.metadata.duplicate,
        spCertificateExpirationMessageType: getExpirationMessageType(action.metadata.parsedMetadata.validUntil),
        certificateValidTo: Moment.utc(action.metadata.parsedMetadata.validUntil),
        parseUrlInProgress: false,
        isApplicationReplaced: false
      };
    case types.PARSE_FROM_URL_FAIL:
      return {
        ...state,
        errorMsg: messages[action.errorMsg] || messages.UNABLE_TO_PARSE_METADATA_URL_OR_XML,
        parseUrlInProgress: false,
      };
    case types.PARSE_FROM_XML_START:
      return {
        ...state,
        errorMsg: null,
        parseXmlInProgress: true
      };
    case types.PARSE_FROM_XML_SUCCESS:
      return {
        ...state,
        errorMsg: null,
        importMetadata: action.metadata.parsedMetadata,
        downloadUrl: '',
        defaultSamlNameIdFormatEnum: action.metadata.parsedMetadata.samlNameIdFormats.filter(
            e => e.samlNameIdFormatEnum
                === state.defaultSamlNameIdFormatEnum).length
        > 0 ? state.defaultSamlNameIdFormatEnum
            : action.metadata.parsedMetadata.defaultSamlNameIdFormatEnum,
        unspecifiedNameIdFormatAttributeEnum: action.metadata.parsedMetadata.unspecifiedNameIdFormatAttributeEnum,
        selectedImportOption: samlConstants.IMPORT_FROM_FILE,
        duplicate: action.metadata.duplicate,
        spCertificateExpirationMessageType: getExpirationMessageType(action.metadata.parsedMetadata.validUntil),
        certificateValidTo: Moment.utc(action.metadata.parsedMetadata.validUntil),
        parseXmlInProgress: false,
        isApplicationReplaced: false
      };
    case types.PARSE_FROM_XML_FAIL:
      return {
        ...state,
        errorMsg: messages[action.errorMsg] || messages.UNABLE_TO_PARSE_METADATA_URL_OR_XML,
        parseXmlInProgress: false,
      };
    case types.CLEAR_IMPORT_URL:
      return {
        ...state,
        importMetadata: null,
        duplicate: null,
      };
    case types.UPDATE_APPLICATION_START:
      return {
        ...state,
        errorMsg: null,
        updateAppInProgress: true
      };
    case types.UPDATE_APPLICATION_SUCCESS:
      return {
        ...state,
        errorMsg: null,
        updateAppInProgress: false,
        isApplicationReplaced: false
      };
    case types.UPDATE_APPLICATION_FAIL:
      return {
        ...state,
        errorMsg: action.errorMsg === 'SBA_APP_NAME_ALREADY_IN_USE' ?
        state.applicationName + messages.APP_NAME_IS_DUPLICATED
        : messages[action.errorMsg] || messages.GENERIC_ERROR,
        updateAppInProgress: false
      };

    case types.GET_APPLICATION_START:
      return {
        ...state,
        errorMsg: null,
        getAppInProgress: true
      };
    case types.GET_SAML_APPLICATION_SUCCESS:
      return {
        ...state,
        errorMsg: null,
        applicationId: action.metadata.id,
        applicationType: action.metadata.applicationType,
        importMetadata: action.metadata.spSaml2Metadata,
        downloadUrl: action.metadata.spSaml2Metadata.downloadUrl,
        //Handle extended attributes
        idpUserAttributes: action.metadata.spSaml2Metadata.idpUserAttributes.map(
            o => {
              if(o.idpUserAttributeEnum === EXTENDED_ATTRIBUTE) {
                return {
                  userAttributeName: o.userAttributeName,
                  idpUserAttributeEnum: o.userSpecifiedValue,
                  userSpecifiedValue: o.userSpecifiedValue
                }
              } else {
                return o;
              }
            }
        ).filter(
            attr => REGULAR_USER_ATTRIBUTES.includes(attr.idpUserAttributeEnum)
                || JSON.parse(getExtendedAttributes())[attr.idpUserAttributeEnum]
        ),
        idpUserGroupAttributes: action.metadata.spSaml2Metadata.idpUserGroupAttributes,
        applicationName: action.metadata.name,
        userFriendlyName: action.metadata.userFriendlyName,
        defaultSamlNameIdFormatEnum: action.metadata.spSaml2Metadata.defaultSamlNameIdFormatEnum,
        unspecifiedNameIdFormatAttributeEnum: action.metadata.spSaml2Metadata.unspecifiedNameIdFormatAttributeEnum,
        selectedImportOption: action.metadata.spSaml2Metadata.downloadUrl
            ? samlConstants.IMPORT_FROM_URL : samlConstants.IMPORT_FROM_FILE,
        getAppInProgress: false,
        spCertificateExpirationMessageType: getExpirationMessageType(action.metadata.spSaml2Metadata.validUntil),
        certificateValidTo: Moment.utc(action.metadata.spSaml2Metadata.validUntil),
        lastCertificateRotationDate: action.metadata.lastCertificateRotationDate
            ? Moment.utc(action.metadata.lastCertificateRotationDate) : null,
        isApplicationReplaced: false
      };
    case types.GET_OIDC_APPLICATION_SUCCESS:
      return {
        ...state,
        errorMsg: null,
        applicationId: action.metadata.id,
        applicationName: action.metadata.name,
        userFriendlyName: action.metadata.userFriendlyName,
        applicationType: action.metadata.applicationType,
        oidcProfile: action.metadata.oidcProfile,
        oidcRedirectUris:  action.metadata.oidcProfile.oidcRedirectUris,
        oidcScope: (action.metadata.oidcProfile.oidcScope && action.metadata.oidcProfile.oidcScope.length > 0)
          ? action.metadata.oidcProfile.oidcScope.map(
            scope => {
              if (scope.scopeName === "profile" || scope.scopeName === "email") {
                return {
                  ...scope,
                  isDefault: true
                };
              }
              return scope;
            }).map(scope => {
              let customClaims = scope.oidcCustomClaims
                .map(
                  claim => {
                    if (claim.idpUserAttributeEnum === EXTENDED_ATTRIBUTE) {
                      return {
                        ...claim,
                        "oidcCustomClaimValue": claim.oidcCustomClaimValue,
                        "idpUserAttributeEnum": claim.oidcCustomClaimValue
                      }
                    }
                    return claim;
                  }
                ).filter(
                  claim => {
                    return REGULAR_USER_ATTRIBUTES.includes(claim.idpUserAttributeEnum)
                    || JSON.parse(getExtendedAttributes())[claim.idpUserAttributeEnum];}
                );
              return {
                ...scope,
                oidcCustomClaims: customClaims
              }
            }
          ) : DEFAULT_SCOPE,
        clientId: action.metadata.oidcProfile.clientId,
        getAppInProgress: false,
      };
    case types.GENERATE_OIDC_CLIENT_CREDENTIALS_SUCCESS:
      return {
        ...state,
        errorMsg: null,
        clientId: action.response.clientId,
        clientSecret: action.response.clientSecret,
        signature: action.response.signature,
        oidcProfile: {
          ...state.oidcProfile,
          clientId: action.response.clientId,
          clientSecret: action.response.clientSecret,
          signature: action.response.signature
        }
      };
    case types.GENERATE_OIDC_CLIENT_CREDENTIALS_FAIL:
      return {
        ...state,
        errorMsg: messages.GENERIC_ERROR
      };
    case types.ADD_OIDC_APP_SUCCESS:
      return {
        ...state,
        errorMsg: null,
        applicationId: action.response.id,
        clientId: action.response.oidcProfile.clientId,
      };
    case types.ADD_OIDC_APP_FAIL:
      return {
        ...state,
        errorMsg: action.errorMsg === 'SBA_APP_NAME_ALREADY_IN_USE' ?
            state.applicationName + messages.APP_NAME_IS_DUPLICATED
            : messages[action.errorMsg] || messages.GENERIC_ERROR,
      };
    case types.GET_APPLICATION_FAIL:
      return {
        ...state,
        errorMsg: action.errorMsg,
        getAppInProgress: false,
        modalStartUsingNewIdpCertificateIsShown: false
      };
    case types.DELETE_SP_START:
      return {
        ...state,
        errorMsg: null,
        deleteAppInProgress: true
      };
    case types.DELETE_SP_SUCCESS:
      return {
        ...state,
        errorMsg: null,
        deleteAppInProgress: false
      };
    case types.DELETE_SP_FAIL:
      return {
        ...state,
        errorMsg: action.errorMsg,
        deleteAppInProgress: false
      };
    case types.DELETE_USER_ATTRIBUTE:
      return {
        ...state,
        idpUserAttributes: state.idpUserAttributes.filter(
            item => item !== action.targetAttribute)
      };

    case types.ADD_USER_ATTRIBUTE :
      return {
        ...state,
        idpUserAttributes: [...state.idpUserAttributes, action.newUserAttribute]
      };

    case types.UPDATE_USER_ATTRIBUTES:
      return {
        ...state,
        idpUserAttributes: state.idpUserAttributes.map((item, index) => {
          if (index.toString() !== action.payload.target.id.toString()) {
            return item
          }
          return {
            ...item,
            [action.payload.target.name]: action.payload.target.value,
          }
        })
      };

    case types.DELETE_USER_GROUP_ATTRIBUTE:
      return {
        ...state,
        idpUserGroupAttributes: state.idpUserGroupAttributes.filter(
            item => item !== action.targetAttribute)
      };

    case types.ADD_USER_GROUP_ATTRIBUTE :
      return {
        ...state,
        idpUserGroupAttributes: [...state.idpUserGroupAttributes, action.newUserGroupAttribute]
      };

    case types.UPDATE_USER_GROUP_ATTRIBUTES:
      return {
        ...state,
        idpUserGroupAttributes: state.idpUserGroupAttributes.map((item, index) => {
          if (index.toString() !== action.payload.target.id.toString()) {
            return item
          }
          return {
            ...item,
            [action.payload.target.name]: action.payload.target.value,
          }
        })
      };


    case types.DELETE_OIDC_REDIRECT_URI:
      return {
        ...state,
        oidcRedirectUris: state.oidcRedirectUris.filter(
            item => item !== action.targetOidcRedirectUri)
      };

    case types.ADD_OIDC_REDIRECT_URI :
      return {
        ...state,
        oidcRedirectUris: [...state.oidcRedirectUris, action.newOidcRedirectUri]
      };

    case types.UPDATE_OIDC_REDIRECT_URI:
      return {
        ...state,
        oidcRedirectUris: state.oidcRedirectUris.map((item, index) => {
          if (index.toString() !== action.payload.target.id.toString()) {
            return item
          }
          return {
            ...item,
            [action.payload.target.name]: action.payload.target.value.trim(),
          }
        })
      };

    case types.GET_WS_FED_APPLICATION_SUCCESS:
      return {
        ...state,
        errorMsg: null,
        applicationId: action.metadata.id,
        applicationName: action.metadata.name,
        userFriendlyName: action.metadata.userFriendlyName,
        applicationType: action.metadata.applicationType,
        wsFederationProfile: action.metadata.wsFederationProfile,
        redirectUri: action.metadata.wsFederationProfile.redirectUri,
        lastCertificateRotationDate: action.metadata.lastCertificateRotationDate
            ? Moment.utc(action.metadata.lastCertificateRotationDate) : null,
        getAppInProgress: false,
      };
    case types.ADD_WS_FED_APP_SUCCESS:
      return {
        ...state,
        errorMsg: null,
        applicationId: action.response.id,
        showModalWsFedIdpMetadata: true,
        lastCertificateRotationDate: action.response.lastCertificateRotationDate
            ? Moment.utc(action.response.lastCertificateRotationDate) : null
      };
    case types.ADD_WS_FED_APP_FAIL:
      return {
        ...state,
        errorMsg: action.errorMsg === 'SBA_APP_NAME_ALREADY_IN_USE' ?
            state.applicationName + messages.APP_NAME_IS_DUPLICATED
            : messages[action.errorMsg] || messages.GENERIC_ERROR,
      };
    case types.UPDATE_WS_FED_REDIRECT_URI:
      return {
        ...state,
        redirectUri: action.payload.trim()
      };
    case types.SHOW_WS_FED_IDP_METADATA_POPUP:
      return {
        ...state,
        showModalWsFedIdpMetadata: true,
      };
    case types.HIDE_WS_FED_IDP_METADATA_POPUP:
      return {
        ...state,
        showModalWsFedIdpMetadata: false,
      };

    case types.RECOVER_APPLICATION:
      return {
        ...state,
        errorMsg: null,
        applicationId: action.payload.id,
        importMetadata: action.payload.spSaml2Metadata,
        idpUserAttributes: action.payload.spSaml2Metadata.idpUserAttributes,
        idpUserGroupAttributes: action.payload.spSaml2Metadata.idpUserGroupAttributes,
        applicationName: action.payload.name,
        userFriendlyName: action.payload.userFriendlyName,
        defaultSamlNameIdFormatEnum: action.payload.spSaml2Metadata.defaultSamlNameIdFormatEnum,
        unspecifiedNameIdFormatAttributeEnum: action.payload.spSaml2Metadata.unspecifiedNameIdFormatAttributeEnum,
        downloadUrl: action.payload.spSaml2Metadata.downloadUrl,
        selectedImportOption: action.payload.spSaml2Metadata.downloadUrl
            ? samlConstants.IMPORT_FROM_URL : samlConstants.IMPORT_FROM_FILE,
        lastCertificateRotationDate: action.payload.lastCertificateRotationDate
            ? Moment.utc(action.payload.lastCertificateRotationDate) : null,
        duplicate: null,
        isApplicationReplaced: false
      };
    case types.REPLACE_APPLICATION:
      return {
        ...state,
        errorMsg: null,
        applicationId: action.appId,
        defaultSamlNameIdFormatEnum: action.payload.samlNameIdFormats.filter(
            e => e.samlNameIdFormatEnum
                === state.defaultSamlNameIdFormatEnum).length
        > 0 ? state.defaultSamlNameIdFormatEnum
            : action.payload.defaultSamlNameIdFormatEnum,
        unspecifiedNameIdFormatAttributeEnum: state.defaultSamlNameIdFormatEnum
        === samlConstants.UNSPECIFIED
            ? state.unspecifiedNameIdFormatAttributeEnum
            : samlConstants.UNSPECIFIED_NAME_ID_USER_PRINCIPAL_NAME,
        lastCertificateRotationDate: new Moment(),
        duplicate: null,
        isApplicationReplaced: true
      };
    case types.CLEAR_ERROR_MESSAGE:
      return {
        ...state,
        errorMsg: null
      };
    case types.UPDATE_APP_NAME:
      return {
        ...state,
        applicationName: action.payload
      };
    case types.UPDATE_USER_FRIENDLY_NAME:
      return {
        ...state,
        userFriendlyName: action.payload
      };
    case types.UPDATE_DEFAULT_NAME_ID:
      return {
        ...state,
        defaultSamlNameIdFormatEnum: action.payload
      };
    case types.UPDATE_UNSPECIFIED_NAME_ID_FORMAT_ATTRIBUTE:
      return {
        ...state,
        unspecifiedNameIdFormatAttributeEnum: action.payload
      };
    case types.UPDATE_DOWNLOAD_URL:
      return {
        ...state,
        downloadUrl: action.payload
      };

    case types.SET_ERROR_MESSAGE:
      return {
        ...state,
        errorMsg: action.errorMsg,
        successMsg: null
      };
    case types.CLEAR_MESSAGES:
      return {
        ...state,
        errorMsg: null,
        idpErrorMsg: null,
        successMsg: null
      };
    case types.ADD_SP_FAIL:
      return {
        ...state,
        errorMsg: action.errorMsg === 'SBA_APP_NAME_ALREADY_IN_USE' ?
            state.applicationName + messages.APP_NAME_IS_DUPLICATED
            : messages[action.errorMsg] || messages.GENERIC_ERROR
      };
    case types.SHOW_IMPORT_MODAL:
      return {
        ...state,
        showImportModal: true,
      };
    case types.HIDE_IMPORT_MODAL:
      return {
        ...state,
        showImportModal: false,
      };
    case types.SHOW_ALL_METADATA_MODAL:
      return {
        ...state,
        showModalViewAllMetadata: true,
      };
    case types.HIDE_ALL_METADATA_MODAL:
      return {
        ...state,
        showModalViewAllMetadata: false,
      };
    case types.SHOW_EXPIRED_METADATA_CERTIFICATE_MODAL:
      return {
        ...state,
        modalExpiredMetadataCertificateIsShown: true
      };
    case types.HIDE_EXPIRED_METADATA_CERTIFICATE_MODAL:
      return {
        ...state,
        modalExpiredMetadataCertificateIsShown: false
      };

    case types.CHANGE_SELECTED_IMPORT_OPTION:
      return {
        ...state,
        selectedImportOption: action.payload,
      };
    case types.SHOW_START_USING_NEW_IDP_CERTIFICATE_MODAL:
      return {
        ...state,
        modalStartUsingNewIdpCertificateIsShown: true
      };
    case types.HIDE_START_USING_NEW_IDP_CERTIFICATE_MODAL:
      return {
        ...state,
        modalStartUsingNewIdpCertificateIsShown: false
      };
    case types.START_USING_NEW_IDP_CERTIFICATE_SUCCESS:
      return {
        ...state,
        errorMsg: null,
        lastCertificateRotationDate: action.metadata.lastCertificateRotationDate
            ? Moment.utc(action.metadata.lastCertificateRotationDate) : null,
        modalStartUsingNewIdpCertificateIsShown: false,
        isApplicationReplaced: false
      };
    case types.ADD_SCOPE :
      return {
        ...state,
        oidcScope: [...state.oidcScope, NEW_OIDC_SCOPE]
      };
    case types.UPDATE_SCOPE:
      return {
        ...state,
        oidcScope: state.oidcScope.map((scope, index) => {
          if (index.toString() !== action.updatedScopeIndex.toString()) {
            return scope;
          }
          return action.updatedScope;
        })
      };
    case types.DELETE_SCOPE:
      return {
        ...state,
        oidcScope: state.oidcScope.filter((scope, index) =>
            index !== action.scopeToDeleteIndex || scope !== action.scopeToDelete)
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sp.js